// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HOtJ","textarea":"styles_textarea__504Rw"};